import React, { useState } from 'react';
import axios from 'axios';
import { Modal } from 'react-responsive-modal';

const ImageModal = ({ open, onClose, product, onUpdate }) => {
  const [newImages, setNewImages] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleImageUpload = (files) => {
    setNewImages(files);
  };

  const handleDeleteImage = async (imagePath) => {
    try {
      setLoading(true);
      await axios.delete(`/api/products/delete-image/${product.productId}`, {
        data: { imagePath },
      });
      onUpdate();
    } catch (error) {
      console.error('Failed to delete image:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveImages = async () => {
    const formData = new FormData();
    newImages.forEach((file) => {
      formData.append('photos', file);
    });

    try {
      setLoading(true);
      await axios.put(`/api/products/${product.productId}/update-images`, formData);
      onUpdate();
      setNewImages([]);
    } catch (error) {
      console.error('Failed to upload images:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose} center>
      <h2 className="text-2xl font-bold mb-4">Manage Product Images</h2>
      <div className="space-y-4">
        <div className="flex gap-4 flex-wrap">
          {product.photos?.map((photo, index) => (
            <div key={index} className="relative">
              <img
                src={`/uploads/${photo.replace(/\\/g, '/')}`}
                alt={`Product ${index + 1}`}
                className="w-32 h-32 object-cover rounded"
              />
              <button
                onClick={() => handleDeleteImage(photo)}
                className="absolute top-0 right-0 bg-red-600 text-white rounded-full p-1"
              >
                &times;
              </button>
            </div>
          ))}
        </div>

        <div>
          <input
            type="file"
            multiple
            onChange={(e) => handleImageUpload(Array.from(e.target.files))}
            className="border p-2 rounded-md w-full"
          />
        </div>

        <button
          onClick={handleSaveImages}
          disabled={loading}
          className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 disabled:bg-gray-300"
        >
          {loading ? 'Uploading...' : 'Save New Images'}
        </button>
      </div>
    </Modal>
  );
};

export default ImageModal;
